export const parameterCodes = {
  popularity: 'popularity',
  profitability: 'profitability',
}

export default [
  {
    code: parameterCodes.popularity,
    title: 'Популярность',
    score: 4,
  },
  {
    code: parameterCodes.profitability,
    title: 'Прибыльность',
    score: 2,
  },
]




// WEBPACK FOOTER //
// ./src/data/parameters.js